import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { RLink, RRow, RText } from 'recruit/components';
import { PrivacyPolicyUrl } from 'constants/Urls';

export function RPublicFooter() {
    const year = new Date().getFullYear();

    return (
        <FooterBar>
            <Inner>
                <RText tone="secondary" size="sm">
                    © {year} Tandem Recruit. All rights reserved.
                </RText>
                <RRow gap="lg">
                    <RLink href={PrivacyPolicyUrl} size="sm" color={Colors.mediumGrey} underline={false}>
                        Privacy
                    </RLink>
                    <RLink href="https://portal.join-tandem.com/tandem-terms-of-use" size="sm" color={Colors.mediumGrey} underline={false}>
                        Terms
                    </RLink>
                    <RLink href="mailto:support@join-tandem.com" size="sm" color={Colors.mediumGrey} underline={false}>
                        Contact
                    </RLink>
                </RRow>
            </Inner>
        </FooterBar>
    );
}

const FooterBar = styled('footer')({
    backgroundColor: Colors.faintGrey,
    borderTop: `1px solid ${Colors.lightGrey}`,
});

const Inner = styled('div')(({ theme }) => ({
    maxWidth: 1200,
    margin: '0 auto',
    padding: '24px 32px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '24px 16px',
    },
}));
